import './Slider.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSlick from 'react-slick';

const Slider = ReactSlick.default || ReactSlick;
export { Slider };
